import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=79b80188&scoped=true&"
import script from "@/views/Users/Student/Notes.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Notes.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/notes.scss?vue&type=style&index=0&id=79b80188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b80188",
  null
  
)

export default component.exports